<div class="shine" [ngStyle]="style"></div>
